module.exports = __webpack_public_path__ + "media/components/assets/icons/lock_img-7fc344610b8f99e51244bd318cdafb28.svg";